// ─────────────────────────────────────────────────────────────────────────────
// Categorias (produtos) do MySuite — nome → código.
//
// Fica num arquivo só de dados, sem depender de nada, porque a API do MySuite
// devolve o NOME da categoria e é este mapa que traduz para o código que vai no
// ticket. Quem precisa dele são regras puras (o ticket novo, os tickets em
// massa), e elas têm de poder ser testadas sem o app inteiro em volta.
// ─────────────────────────────────────────────────────────────────────────────

export const MAPA_CATEGORIAS = {
  'Space Guardian': 2,
  'Ticket em duplicidade': 173,
  'Space Viking': 207,
  'Space Polaris': 208,
  'Space Area': 211,
  'APP Conferência Preço de Gôndola': 213,
  'APP Venda Fácil': 214,
  'Integração Chatbots': 216,
  'GED / DFe': 217,
  'Space Gemini': 219,
  'WEB API': 220,
  'Hardware e Software Terceiros': 224,
  'Space Analytics BI': 227,
  'Robô DFe': 228,
  'APP SGDM': 229,
  'APP Supervisor Polaris': 232,
  'Uninfe': 233,
  'APP Checkout': 234,
  'Robô Space': 235,
  'APP Autorização Remota': 255,
  'APP Controle de Entregas': 293,
  'APP Check-In': 294,
  'Aplicação WEB DRE': 295,
  'Aplicação WEB Conciliação Bancária': 297,
  'Space Sirius': 299,
  'APP INV': 310,
};
